export default __webpack_public_path__ + "22628606652c0ec5dd892c0eec7a9476.svg";